export { default } from './VideoUGCEditor';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/VideoUGCEditor/index.js